
export default defineNuxtPlugin(async () => {
  const { getUser } = useAuthentication();

  await getUser();
});